import { ProxyInfoType } from '@fd/frontend/model/proxyTypes';
import Flex from '@fd/frontend/components/ui/Flex';
import { proxies } from '@fd/frontend/model/proxyTypes';
import useProxyPoolCreationForm from '@fd/frontend/store/proxyPoolCreationFormStore';
import { useTrafficGbAvailableByProxyType } from '@fd/frontend/hooks/useTrafficAvailableByProxyType';
import clsx from 'clsx';
import Card from '@fd/frontend/components/ui/Card';
import { NavLink } from 'react-router';
import OptionField from '@fd/frontend/components/ProxyPoolCreatePage/OptionFieldCard';
import { DesktopView } from '@fd/frontend/components/responsive';

export default function ProxyTypeSelector() {
  const { setProxyType } = useProxyPoolCreationForm();
  return (
    <>
      <OptionField.Title>Proxy Type</OptionField.Title>
      <div className="flex gap-2 flex-col sm:flex-row">
        {proxies.map((proxyInfo) => (
          <ProxyTypeCard
            key={proxyInfo.type}
            proxyInfo={proxyInfo}
            onClick={() => setProxyType(proxyInfo.type)}
          />
        ))}
      </div>
    </>
  );
}

function ProxyTypeCard({
  proxyInfo,
  onClick,
}: {
  proxyInfo: ProxyInfoType;
  onClick: () => void;
}) {
  const { proxyType } = useProxyPoolCreationForm();

  const availableTrafficGb = useTrafficGbAvailableByProxyType(proxyInfo.type);
  const isAvailable =
    availableTrafficGb !== undefined && availableTrafficGb > 0;
  const isActive = proxyInfo.type === proxyType;

  return (
    <Card
      className={clsx(
        {
          'ring-2 ring-primary-purple/30 border-primary-purple': isActive,
          'ring-2 ring-transparent': !isActive,
        },
        'w-full hover:border-primary-purple'
      )}
      onClick={onClick}
    >
      <Flex.Row className="justify-between items-center">
        <Flex.Row gap="3" className="items-center">
          <div className="bg-proxy-icon-bg h-10 aspect-square rounded-lg flex items-center justify-center">
            {proxyInfo.icon}
          </div>
          <Flex.Col gap="1">
            <span className="text-primary font-semibold">
              {proxyInfo.title}
            </span>
            <Flex.Row gap="3" className="items-center sm:min-h-6">
              <span
                className={clsx(
                  isAvailable ? 'text-primary-purple' : 'text-secondary',
                  'text-sm'
                )}
              >
                Available: {availableTrafficGb?.toFixed(1)} GB
              </span>
              <DesktopView>
                {isActive && (
                  <NavLink
                    to={`/proxies/buy?type=${proxyInfo.type}`}
                    className="inline-block py-1 px-2 text-sm leading-4 rounded-full bg-primary-purple/20 text-primary-purple hover:bg-primary-purple/30"
                  >
                    {availableTrafficGb === 0 ? 'Buy to create' : 'Buy more'}
                  </NavLink>
                )}
              </DesktopView>
            </Flex.Row>
          </Flex.Col>
        </Flex.Row>
      </Flex.Row>
    </Card>
  );
}
